/* TEPORE — interacciones (un solo archivo para todas las páginas) */
(function () {
  'use strict';
  /* Varias secciones cargan este archivo: que solo se active una vez */
  if (window.__tpLoaded) return;
  window.__tpLoaded = true;

  function euros(cents) {
    var n = cents / 100;
    if (Math.round(n) === n) return n + ' €';
    return n.toFixed(2).replace('.', ',') + ' €';
  }

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'No se pudo añadir'); });
      return r.json();
    });
  }

  /* Entradas suaves al hacer scroll */
  function initReveal() {
    var els = document.querySelectorAll('.tp-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('tp-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('tp-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* 1. Portada: pestañas de producto (y deslizar en el móvil) y colores de cada producto */
  function initHero() {
    document.querySelectorAll('[data-tp-hero]').forEach(function (hero) {
      var tabs = Array.prototype.slice.call(hero.querySelectorAll('[data-tp-tab]'));
      var panels = Array.prototype.slice.call(hero.querySelectorAll('[data-tp-panel]'));
      var current = 0;

      var show = function (i) {
        if (i === current || !panels[i]) return;
        current = i;
        tabs.forEach(function (t, k) {
          t.classList.toggle('is-on', k === i);
          t.setAttribute('aria-selected', k === i ? 'true' : 'false');
        });
        panels.forEach(function (p, k) {
          p.classList.toggle('is-on', k === i);
          if (k === i) p.removeAttribute('aria-hidden'); else p.setAttribute('aria-hidden', 'true');
          p.querySelectorAll('a').forEach(function (a) { if (k === i) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); });
        });
      };
      var timer = null, gap = 7000;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function stopAuto() { if (timer) { clearInterval(timer); timer = null; } hero.removeAttribute('data-auto'); }
      function startAuto() {
        if (reduce || panels.length < 2) return;
        hero.setAttribute('data-auto', 'on');
        timer = setInterval(function () { if (!document.hidden) show((current + 1) % panels.length); }, gap);
      }
      function restartBar() { /* reinicia la línea de progreso de la pestaña activa */
        if (!timer) return; hero.removeAttribute('data-auto'); void hero.offsetWidth; hero.setAttribute('data-auto', 'on');
      }
      var rawShow = show;
      show = function (i) { rawShow(i); restartBar(); };
      tabs.forEach(function (t, k) { t.addEventListener('click', function () { stopAuto(); rawShow(k); }); });
      hero.addEventListener('pointerdown', function (e) { if (e.target.closest('.tp-dot, .tp-btn')) stopAuto(); });
      var byHash = function () {
        var h = (location.hash || '').toLowerCase();
        var mapa = { '#calentador': 0, '#manos': 0, '#cojin': 1, '#asiento': 1, '#chaleco': 2, '#cuerpo': 2 };
        var i = mapa.hasOwnProperty(h) ? mapa[h] : -1;
        if (i > -1 && panels[i]) { stopAuto(); rawShow(i); var top = hero.getBoundingClientRect().top + window.scrollY - 60; window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' }); }
      };
      window.addEventListener('hashchange', byHash);
      if (location.hash) byHash(); else startAuto();

      if (panels.length > 1) {
        var x0 = null, y0 = null;
        hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
        hero.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
          x0 = null;
          if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
          stopAuto();
          if (dx < 0) rawShow(Math.min(current + 1, panels.length - 1)); else rawShow(Math.max(current - 1, 0));
        }, { passive: true });
      }

      (panels.length ? panels : [hero]).forEach(function (panel) {
        var img = panel.querySelector('[data-tp-hero-img]');
        var hueco = panel.querySelector('[data-tp-hero-hueco]');
        var ph = panel.querySelector('[data-tp-hero-ph]');
        var name = panel.querySelector('[data-tp-hero-name]');
        var obj = panel.querySelector('.tp-float__obj') || img;
        var dots = panel.querySelectorAll('[data-tp-dot]');
        dots.forEach(function (d) {
          d.addEventListener('click', function () {
            dots.forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
            d.classList.add('is-on'); d.setAttribute('aria-pressed', 'true');
            if (name) name.textContent = d.getAttribute('data-name') || '';
            var src = d.getAttribute('data-img');
            obj.style.opacity = 0;
            setTimeout(function () {
              if (src) { img.src = src; img.hidden = false; if (hueco) hueco.hidden = true; }
              else { img.hidden = true; if (hueco) { hueco.hidden = false; if (ph) ph.textContent = d.getAttribute('data-ph') || ''; } }
              obj.style.opacity = 1;
            }, 250);
          });
        });
      });
    });
  }

  /* 2. Colección: segunda foto al tocar en el móvil */
  function initItems() {
    document.querySelectorAll('.tp-item').forEach(function (it) {
      it.addEventListener('touchstart', function () { it.classList.toggle('is-tap'); }, { passive: true });
    });
  }

  /* 3. El regalo: elegir piezas y ver el precio */
  function initGift() {
    document.querySelectorAll('[data-tp-gift]').forEach(function (box) {
      var opts = Array.prototype.slice.call(box.querySelectorAll('[data-tp-opt]'));
      var tot = box.querySelector('[data-tp-total]');
      var note = box.querySelector('[data-tp-note]');
      var btn = box.querySelector('[data-tp-gift-btn]');
      var t2 = parseInt(box.getAttribute('data-t2') || '0', 10), t3 = parseInt(box.getAttribute('data-t3') || '0', 10);
      var baseNote = note ? note.textContent : '';
      var txtOn = box.getAttribute('data-on') || 'Incluido';
      var txtOff = box.getAttribute('data-off') || 'Añadir';

      function calc() {
        var on = opts.filter(function (o) { return o.classList.contains('is-on'); });
        var sum = on.reduce(function (s, o) { return s + parseInt(o.getAttribute('data-price') || '0', 10); }, 0);
        if (btn) btn.classList.toggle('is-off', on.length === 0);
        if (on.length === 0) {
          tot.textContent = euros(0);
          if (note) note.textContent = box.getAttribute('data-none') || baseNote;
        } else {
          var pct = on.length >= 3 ? t3 : (on.length === 2 ? t2 : 0);
          if (pct > 0) {
            var fin = Math.round(sum * (100 - pct) / 100);
            tot.textContent = euros(fin);
            if (note) note.textContent = (box.getAttribute('data-sep') || 'Por separado') + ' ' + euros(sum) + ' · ' + (box.getAttribute('data-tog') || 'Con el set') + ' ' + euros(fin) + ' (–' + pct + ' %)';
          } else {
            tot.textContent = euros(sum);
            if (note) note.textContent = baseNote;
          }
        }
      }
      /* Productos con tallas o colores: el selector de abajo decide la variante y el precio */
      box.querySelectorAll('[data-tp-var-for]').forEach(function (lab) {
        var sel = lab.querySelector('[data-tp-var-sel]');
        var opt = box.querySelector('[data-tp-opt][data-key="' + lab.getAttribute('data-tp-var-for') + '"]');
        if (!sel || !opt) return;
        function sync() {
          var o = sel.options[sel.selectedIndex];
          opt.setAttribute('data-variant', o.value);
          opt.setAttribute('data-price', o.getAttribute('data-price'));
          var pe = opt.querySelector('[data-tp-opt-p]'); if (pe) pe.textContent = euros(parseInt(o.getAttribute('data-price'), 10));
          calc();
        }
        sel.addEventListener('change', sync);
        opt.__tpVarLabel = lab;
      });

      opts.forEach(function (o) {
        o.addEventListener('click', function () {
          if (o.hasAttribute('data-fixed')) return;
          o.classList.toggle('is-on');
          if (o.__tpVarLabel) o.__tpVarLabel.hidden = !o.classList.contains('is-on');
          var c = o.querySelector('[data-tp-opt-c]');
          if (c) c.textContent = o.classList.contains('is-on') ? txtOn : txtOff;
          o.setAttribute('aria-pressed', o.classList.contains('is-on') ? 'true' : 'false');
          calc();
        });
      });
      calc();

      if (btn) {
        btn.addEventListener('click', function (e) {
          var on = opts.filter(function (o) { return o.classList.contains('is-on'); });
          if (!on.length) { e.preventDefault(); return; }
          var items = on.map(function (o) { return { id: parseInt(o.getAttribute('data-variant') || '0', 10), quantity: 1 }; })
            .filter(function (i) { return i.id > 0; });
          if (!items.length || items.length !== on.length) return; /* sin productos enlazados: sigue el enlace */
          e.preventDefault();
          btn.setAttribute('disabled', '');
          addToCart(items).then(function () { window.location.href = '/cart'; })
            .catch(function () { btn.removeAttribute('disabled'); window.location.href = btn.getAttribute('href') || '/cart'; });
        });
      }
    });
  }

  /* Ficha de producto: color, complemento, añadir a la cesta y barra fija */
  function initPdp() {
    var root = document.querySelector('[data-tp-pdp]');
    if (!root) return;
    var dataEl = root.querySelector('[data-tp-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var idInput = root.querySelector('[data-tp-id]');
    var priceEls = document.querySelectorAll('[data-tp-price]');
    var btn = root.querySelector('[data-tp-add]');
    var msg = root.querySelector('[data-tp-msg]');
    var media = root.querySelector('[data-tp-media]');
    var addon = root.querySelector('[data-tp-addon]');
    var soldOut = root.getAttribute('data-sold') || 'Agotado';
    var addTxt = btn ? btn.textContent : '';

    function select(v) {
      if (!v) return;
      idInput.value = v.id;
      priceEls.forEach(function (p) { p.textContent = euros(v.price); });
      if (btn) {
        if (v.available) { btn.removeAttribute('disabled'); btn.textContent = addTxt; }
        else { btn.setAttribute('disabled', ''); btn.textContent = soldOut; }
      }
      if (media && v.featured_media) {
        var slide = media.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (slide) {
          if (window.innerWidth <= 990) media.scrollTo({ left: slide.offsetLeft - media.offsetLeft, behavior: 'smooth' });
          else media.insertBefore(slide, media.firstChild);
        }
      }
    }

    /* Opciones (modelo, color, talla…): se busca la variante que coincide con todas las elegidas */
    var firstId = parseInt(idInput.value, 10);
    var chosen = ((variants.filter(function (v) { return v.id === firstId; })[0]) || variants[0] || { options: [] }).options.slice();
    function refreshNotes() {
      root.querySelectorAll('[data-tp-note-opt]').forEach(function (n) {
        var g = n.closest('[data-tp-optgroup]'); var oi = parseInt(g.getAttribute('data-oindex'), 10);
        n.hidden = chosen[oi] !== n.getAttribute('data-tp-note-opt');
      });
    }
    var noMatch = root.getAttribute('data-nomatch') || 'No disponible';
    root.querySelectorAll('[data-tp-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        var oi = parseInt(b.getAttribute('data-oindex'), 10);
        chosen[oi] = b.getAttribute('data-ovalue');
        root.querySelectorAll('[data-tp-opt][data-oindex="' + oi + '"]').forEach(function (x) {
          var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var v = variants.filter(function (vv) { return vv.options.every(function (o, i) { return o === chosen[i]; }); })[0];
        if (v) select(v);
        else if (btn) { btn.setAttribute('disabled', ''); btn.textContent = noMatch; }
        refreshNotes();
      });
    });
    refreshNotes();

    if (addon) {
      var head = addon.querySelector('[data-tp-addon-toggle]');
      var box = addon.querySelector('.tp-addon__box');
      head.addEventListener('click', function () {
        addon.classList.toggle('is-on');
        if (box) box.textContent = addon.classList.contains('is-on') ? '✓' : '';
      });
      addon.querySelectorAll('[data-tp-addon-var]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.stopPropagation();
          addon.querySelectorAll('[data-tp-addon-var]').forEach(function (x) { x.classList.remove('is-on'); });
          b.classList.add('is-on');
          addon.setAttribute('data-id', b.getAttribute('data-id'));
        });
      });
    }

    var form = root.querySelector('form[data-tp-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var items = [{ id: parseInt(idInput.value, 10), quantity: 1 }];
        if (addon && addon.classList.contains('is-on') && addon.getAttribute('data-id')) {
          items.push({ id: parseInt(addon.getAttribute('data-id'), 10), quantity: 1 });
        }
        btn.setAttribute('disabled', '');
        if (msg) msg.textContent = '';
        addToCart(items).then(function () { window.location.href = '/cart'; })
          .catch(function (err) { btn.removeAttribute('disabled'); if (msg) msg.textContent = err.message; });
      });
    }

    var sticky = document.querySelector('[data-tp-sticky]');
    if (sticky && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      }).observe(btn);
      var sb = sticky.querySelector('button');
      if (sb) sb.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }
  }

  /* Seguimiento: abre el buscador con el número escrito */
  function initCookies() {
    document.querySelectorAll('[data-tp-cookies]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var pb = window.privacyBanner;
        if (pb && typeof pb.showPreferences === 'function') { e.preventDefault(); pb.showPreferences(); }
      });
    });
  }

  function initThumbs() {
    document.querySelectorAll('[data-tp-thumbs]').forEach(function (bar) {
      var media = bar.parentNode.querySelector('[data-tp-media]');
      if (!media) return;
      var slides = media.querySelectorAll('.tp-pdp__slide');
      var thumbs = bar.querySelectorAll('[data-tp-thumb]');
      function mark(i) { thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); }); }
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          var sl = slides[i]; if (!sl) return;
          if (window.innerWidth <= 990) media.scrollTo({ left: sl.offsetLeft - media.offsetLeft, behavior: 'smooth' });
          else window.scrollTo({ top: sl.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
          mark(i);
        });
      });
      var tm;
      media.addEventListener('scroll', function () {
        clearTimeout(tm);
        tm = setTimeout(function () {
          var best = 0, d = Infinity;
          slides.forEach(function (sl, k) { var x = Math.abs(sl.offsetLeft - media.offsetLeft - media.scrollLeft); if (x < d) { d = x; best = k; } });
          mark(best);
        }, 80);
      }, { passive: true });
    });
  }

  function initTrack() {
    document.querySelectorAll('[data-tp-track]').forEach(function (box) {
      var f = box.querySelector('[data-tp-track-form]'); if (!f) return;
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var n = (f.querySelector('input').value || '').replace(/\s+/g, '');
        if (!n) return;
        window.open((box.getAttribute('data-url') || '') + encodeURIComponent(n), '_blank', 'noopener');
      });
    });
  }

  /* Cesta: cambiar cantidad, quitar y añadir sugerencias o sets */
  function initCart() {
    var root = document.querySelector('[data-tp-cart]'); if (!root) return;
    root.addEventListener('click', function (e) {
      var q = e.target.closest('[data-tp-q]');
      if (q) {
        e.preventDefault(); q.disabled = true;
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: parseInt(q.getAttribute('data-tp-q'), 10), quantity: Math.max(0, parseInt(q.getAttribute('data-q'), 10)) }) })
          .then(function () { window.location.reload(); }).catch(function () { q.disabled = false; });
        return;
      }
      var a = e.target.closest('[data-tp-add-ids]');
      if (a) {
        e.preventDefault(); a.disabled = true;
        var count = {};
        var lista = a.getAttribute('data-tp-add-ids').split(',');
        var pack = a.closest('.tp-pack');
        if (pack) pack.querySelectorAll('[data-tp-pack-var]').forEach(function (s) { lista.push(s.value); });
        lista.forEach(function (id) { id = String(id).trim(); if (id) count[id] = (count[id] || 0) + 1; });
        var items = Object.keys(count).map(function (id) { return { id: parseInt(id, 10), quantity: count[id] }; });
        addToCart(items).then(function () { window.location.reload(); }).catch(function () { a.disabled = false; });
      }
    });
  }

  /* Medidas y materiales: pestañas entre las dos piezas */
  function initMed() {
    document.querySelectorAll('[data-tp-med]').forEach(function (box) {
      var tabs = Array.prototype.slice.call(box.querySelectorAll('[data-tp-med-tab]'));
      var panels = Array.prototype.slice.call(box.querySelectorAll('[data-tp-med-panel]'));
      tabs.forEach(function (t, k) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x, j) { x.classList.toggle('is-on', j === k); x.setAttribute('aria-selected', j === k ? 'true' : 'false'); });
          panels.forEach(function (p, j) { p.classList.toggle('is-on', j === k); if (j === k) p.removeAttribute('aria-hidden'); else p.setAttribute('aria-hidden', 'true'); });
        });
      });
    });
  }

  /* Cabecera: una línea fina aparece al bajar */
  function initHeader() {
    var hd = document.querySelector('.tp-header'); if (!hd) return;
    var f = function () { hd.classList.toggle('is-scrolled', window.scrollY > 8); };
    f(); window.addEventListener('scroll', f, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal(); initHero(); initItems(); initGift(); initPdp(); initHeader(); initMed(); initCart(); initTrack(); initCookies(); initThumbs();
  });
})();
